import React__default from 'react';
import { H4 } from '@zooplus/ui-components';
import { useTranslation } from '../../../hooks/use-translations.js';
import styles from './ProductsTitle.module.scss.js';
import '../../../node_modules/@zooplus/commons-lang/dist/es/gen/lang.js';
import { useSiteContext } from '../../../node_modules/@zooplus/commons-lang/dist/es/components/SiteProvider.js';
import '../../../node_modules/@zooplus/commons-lang/dist/es/hooks/use-translation.js';

const ProductsTitle = (props) => {
    const { site } = useSiteContext();
    const { t } = useTranslation(site.realm);
    return (React__default.createElement(H4, { className: styles.title }, props.numberOfArticles
        ? `${t('checkout.common.articles')} (${props.numberOfArticles})`
        : t('checkout.common.articles')));
};

export { ProductsTitle };
//# sourceMappingURL=ProductsTitle.js.map
